import React, {useState,useEffect} from 'react';
import '../../../App.css';
import Navbar from '../../../components/Navbar';
import Banner from '../../../components/Banner';
import Footer from '../../../components/Footer';
import Reaction from '../../../components/Reaction';
import IconWhatsapp from '../../../local-assets/icon-whatsapp.png';
import IconEmail from '../../../local-assets/icon-email.png';
import ThumbsUp from '../../../local-assets/thumbs-up.png';
import ThumbsDown from '../../../local-assets/thumbs-down.png';
import BreadCrumbHome from '../../../local-assets/breadcrumb-home.png';
import Contact from '../../../components/Contact';
import LastUpdate from '../../../components/LastUpdate';
import { useLocation } from 'react-router-dom'; // 1. IMPORT INI


import LotReserveParkingBanner from '../../../local-assets/faq-detail/banner-lot-reserve-parking.svg';
import DetailValidasiKtp1 from '../../../local-assets/faq-detail/detail-validasi-ktp-v1.png';
import DetailValidasiKtp2 from '../../../local-assets/faq-detail/detail-validasi-ktp-v2.png';
import DetailValidasiKtp3 from '../../../local-assets/faq-detail/detail-validasi-ktp-v3.png';

const Index = () => {
const location = useLocation();
  const faqData = location.state?.faqData;

  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const safeDateString = dateString.replace(" ", "T");
    const date = new Date(safeDateString);
    return date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
    });
    };


  return (
    <div className="bg-white min-h-screen  flex flex-col">
      <Navbar />
      <Banner
          image={process.env.REACT_APP_S3 + "banner_faq.png"} 
          beforePage="FAQ"
          currentPage="Detail FAQ" 
      />
      <div className="mx-auto px-4 md:px-24 w-full relative z-10 mb-16">
          <div className="rounded-2xl md:rounded-3xl">
              <div className="mb-10 md:mb-16">
                  <h1 className="text-2xl md:text-3xl lg:text-3xl font-bold text-[#101828] mb-3 leading-snug">
                      {faqData?.question}
                  </h1>
                    <label className="mt-4 text-[#101828] text-base md:text-base font-normal">
                        Publish On : {formatDate(faqData?.created_at)}
                    </label>
              </div>
              {
                faqData?.youtube_id != null &&
                <div className="w-full mx-auto rounded-lg overflow-hidden shadow-lg mb-16">
                    {/* aspect-video akan otomatis membuat rasio 16:9 yang sempurna untuk YouTube */}
                    <iframe
                        className="w-full aspect-video"
                        src={`https://www.youtube.com/embed/${faqData?.youtube_id}`} // <-- Gunakan { } di sini
                        title="YouTube video"
                        frameBorder="0"
                        allowFullScreen
                    ></iframe>
                </div>
            }
              <div className="flex flex-col gap-12 md:gap-20">
                  <div className="flex flex-col md:flex-row gap-8 md:gap-12">
                      <div className="w-fulltext-left justify-center md:justify-end">
                          <label className="mt-4 text-[#101828] text-base md:text-base font-normal">
                            {faqData?.answer}
                          </label>
                      </div>
                  </div>
                </div>
              <LastUpdate/>
          </div>
      </div>
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;